import { render, staticRenderFns } from "./ProjectInternalLayouts.vue?vue&type=template&id=61ec2282"
import script from "./ProjectInternalLayouts.vue?vue&type=script&lang=js"
export * from "./ProjectInternalLayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports